<template>
  <div
    class="archive-detail-view page"
  >
    <div class="page__inner">
      <AppPageLoader :collection="pageCollection" @loaded="onPageLoaded">
        <AppArchiveHero
          v-if="state.data"
          :title="state.data.title"
          :image="state.data.main_image"
          :publish-time="state.data.publish_time"
          class="archive-detail-view__archive-hero"
        />
        <div
          v-if="state.data"
        >
          <AppRichTextBlock :data="{}" class="app-rich-text">
            <p>{{ state.data.introduction }}</p>
          </AppRichTextBlock>
          <AppDynamicBlock
            :is="useBlock(block)"
            v-for="block in state.data.content"
            :key="`block_${block.id}`"
            :data="block"
          />
          <ClientOnly>
            <LayoutsShare v-if="state.data?.share" />
          </ClientOnly>

          <AppSterBanner />
        </div>
      </AppPageLoader>
    </div>
    <AppAnimatedTitle />
    <LayoutsFooter />
  </div>
</template>

<script setup lang="ts">

import { reactive } from 'vue'
import { useBlock, useDate } from '#imports'
import { TArchivePage } from '~/types/page-types'

const pageCollection = 'articles'

type TState = {
  data?: TArchivePage
  date?: String
};

const state: TState = reactive({
  data: undefined,
  date: undefined
})

const onPageLoaded = (data) => {
  state.data = data
  state.date = useDate(data.start_time || data.date_created).value
}

</script>

<style scoped lang="postcss">
.archive-detail-view {
  &__archive-hero {
    @mixin app-show-hero;
  }
}

</style>
